import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { fuseAnimations } from '@fuse/animations';
import { Container } from 'app/models/container.model';
import { DeviceLatestStatus } from 'app/models/device-latest-status.model';
import { DeviceAllRequest } from 'app/models/deviceAllRequest.model';
import { ContainerService } from 'app/services/container.service';
import { DateConvertService } from 'app/services/date-convert.service';
import { DeviceRequestService } from 'app/services/device-request.service';
import * as moment from 'moment';
import { Moment } from 'moment';
import { ApexAxisChartSeries, ApexChart, ApexDataLabels, ApexGrid, ApexStroke, ApexTheme, ApexTitleSubtitle, ApexTooltip, ApexXAxis, ApexYAxis, ChartComponent } from 'ng-apexcharts';
import { NgxSpinnerService } from 'ngx-spinner';

export type ChartOptions = {
    series: ApexAxisChartSeries;
    chart: ApexChart;
    xaxis: ApexXAxis;
    yaxis: ApexYAxis;
    tooltip: ApexTooltip;
    theme:ApexTheme;
    colors:string[];
    fill:any
    dataLabels: ApexDataLabels;
    grid: ApexGrid;
    stroke: ApexStroke;
    title: ApexTitleSubtitle;
  };

@Component({
    selector: 'container-view',
    templateUrl: './container-view.component.html',
    styleUrls: ['./container-view.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
    providers:[DatePipe]
})
export class ContainerViewComponent implements OnInit {
    @ViewChild("msfChart") msfChart: ChartComponent;
    public msfChartOptions: Partial<ChartOptions>;
    @ViewChild("heatChart") heatChart: ChartComponent;
    public heatChartOptions: Partial<ChartOptions>;
    @ViewChild("batChart") batChart: ChartComponent;
    public batChartOptions: Partial<ChartOptions>;

    @ViewChild(MatSort) private _sort: MatSort;
    @ViewChild(MatPaginator) private _paginator: MatPaginator;
    
    private _dataSource: MatTableDataSource<DeviceAllRequest> = undefined;
    public get dataSource(): MatTableDataSource<DeviceAllRequest> {
        return this._dataSource;
    }
    public pageLenght:number;
    public sortActive=null;
    public sortDirection=null;

    private _requestAllList: Array<DeviceAllRequest> = [];
    public get requestAllList() {
        return this._requestAllList;
    }

    public get displayedColumns(): Array<string> {
        return this._displayedColumns;
    }
    private _displayedColumns = ['name','slr', "bat", "sck", "msf", "date"];
    

    public deviceId;
    public selectTime?:Moment;
    public container:Container; 
    public startDate = new Date(new Date().setDate(new Date().getDate() - 7));
    public endDate = new Date();
 
    private _msfList: Array<DeviceAllRequest> = [];

    private _requestStatsList: Array<DeviceAllRequest> = [];
    public get requestStatsList(): Array<DeviceAllRequest> {
        return this._requestStatsList;
    }

    constructor(
        private deviceRequest: DeviceRequestService, 
        private _spinner:NgxSpinnerService,
        private dateConvert: DateConvertService, 
        private route: ActivatedRoute,
        private _containerService:ContainerService,
        private datePipe:DatePipe) {
            this.msfChartOptions = {
                series: [
                  {
                    name: "Doluluk",
                    data: [0]
                  }
                ],
                chart: {
                  height: 350,
                  type: "line",
                  zoom: {
                    enabled: true
                  }
                },
                 theme: {
                     mode: 'dark', 
                     palette: 'palette1', 
                     monochrome: {
                         enabled: false,
                         color: '#255aee',
                         shadeTo: 'dark',
                         shadeIntensity: 0.65
                     },
                 },
                dataLabels: {
                  enabled: false
                },
                stroke: {
                  curve: "straight"
                },
                title: {
                  text: "Cihaz Doluluk Ölçümü",
                  align: "left"
                },
                xaxis: {
                type: 'category',
                  categories: []
                },
                yaxis: {
                    labels: {
                      offsetX: 10
                    }
                  },
                  grid: {
                    show:true,
                    padding: {
                      left: 30,
                      right: 30,
                    }
                  }
            };
            
            this.heatChartOptions = {
                series: [{
                    name: 'CPU Sıcaklığı',
                    data: [0]
                  }],
                chart: {
                  height: 350,
                  type: "area",
                },
            };
            this.batChartOptions = {
                series: [{
                    name: 'Batarya Durumu',
                    data: [0]
                  }, {
                    name: 'Solar Batarya Durumu',
                    data: [0]
                }],
                chart: {
                  height: 350,
                  type: "area",
                }
            };
        }
     async ngOnInit() {
        this.selectTime=moment();
        await this.getContainer();
        await this.getByDateBetweenRequests();
        await this.getAllRequestList();
        await this.pageCount();
        await this.getContainerTimeClick();
    }
    
    private async getContainer(){
        this.route.queryParamMap.subscribe(params => {

            this.deviceId = params['params']['deviceId']
        });
        try {
            this._spinner.show('loading')
            this.container = await this._containerService.getByDeviceContainer(this.deviceId);
                        
            this._spinner.hide('loading')
        } catch (error) {
            this._spinner.hide('loading')
            console.warn(error);
        }
    }

    public async getAllRequestList():Promise<DeviceLatestStatus>{
        try {
            this._spinner.show('loading');
            
            this._requestAllList = await this.deviceRequest.getRequestAllPaginated(
                this.deviceId,
                this._paginator!.pageIndex,
                this._paginator!.pageSize,
                this.sortActive,
                this.sortDirection);

                await this.updateTableDataSource();

                this.dataSource.sortingDataAccessor = (item, property) => {
                    switch (property) {
                       case 'frm' : return item.firmware;
                       case 'gpS_Enlem' : return item.gpS_Enlem;
                       case 'gpS_Boylam' : return item.gpS_Boylam;
                       case 'gpS_Fix' : return item.gpS_Fix;
                       case 'gpS_Uydu_Sayisi' : return item.gpS_UyduSayisi;
                       case 'gpS_Dinleme_Sayisi' : return item.gpS_DinlemeSayisi;
                       case 'gpS_Rakim' : return item.gpS_Rakim;
                       case 'slr' : return item.solarEnerjiVoltaj;
                       case 'bat' : return item.batarya;
                       case 'sck' : return item.cpuSicaklik;
                       case 'gsq' : return item.gpS_UyduSayisi;
                       case 'ack' : return item.acikKalmaSuresi;
                       case 'ags' : return item.gsM_BaglantiSuresi;
                       case 'msf' : return item.mesafe;
                       case 'dbG0' : return item.yetersizBataryaUyanamamaCount;
                       case 'dbG1' : return item.gsM_SinyaliYakalayamamaCount;
                       case 'dbG2' : return item.gpS_VerisiFixleyememeCount;
                       case 'dbG3' : return item.sunucuHaberlesememeCount;
                       case 'dbG4' : return item.maxUyaniklikSuresiAsmaCount;
                       case 'date' : return item.sonBaglantiTarih;
                      default: return item[property];
                 }
                }

            this._spinner.hide('loading');
        } catch (error) {
            this._spinner.hide('loading');
            console.warn(error);
            return;
        }
    }

    public async pageCount(){
        try {            
            this.pageLenght = await this.deviceRequest.getRequestCount(this.deviceId);
        } catch (error) {
            this._spinner.hide('loading');
            console.warn(error);
        }
    }

    public async pageEvent(e) {
        try {
            this._spinner.show('loading');
            this._requestAllList = await this.deviceRequest.getRequestAllPaginated(this.deviceId,this._paginator.pageIndex,this._paginator.pageSize,this.sortActive,this.sortDirection);
            this._spinner.hide('loading');
        } catch (error) {
            this._spinner.hide('loading');
            console.warn(error);
            return [];
        }
        this.updateTableDataSource();        
    }

    private async updateTableDataSource(): Promise<void> {        
         this._dataSource = new MatTableDataSource<DeviceAllRequest>(this._requestAllList);
    }

    public async sortData(e){
        try {
            if(e.direction==""){
                this.sortDirection = null;
                this.sortActive = null;
            }
            else{
                this.sortActive = e.active;
                this.sortDirection = e.direction;
            }
            this._spinner.show('loading');   
            this._requestAllList = await this.deviceRequest.getRequestAllPaginated(this.deviceId,this._paginator.pageIndex,this._paginator.pageSize,this.sortActive,this.sortDirection);
            this._spinner.hide('loading');
        } catch (error) {
            this._spinner.hide('loading');
            console.warn(error);
            return [];
        }
        this.updateTableDataSource();
    }

    public async getContainerTimeClick(){
        try {
            this._spinner.show('loading')
            this._msfList = await this.deviceRequest.GetByDayDeviceDetails(this.deviceId,this.selectTime.toDate())            
            this._spinner.hide('loading')
        } catch (error) {
            this._spinner.hide('loading')
            console.warn(error);
        }
        this.MsfData();

    }

    HeatData() {
        var heat = []
        var label = []
        this._requestStatsList.forEach(element => {
            heat.push(parseInt(element.cpuSicaklik)/10)
            label.push(this.datePipe.transform(element.sonBaglantiTarih,'dd.MM.yyyy HH:mm'));
        })
        
        this.heatChartOptions = {
            series: [{
                name: 'CPU Sıcaklığı',
                data: heat.length>0?heat:[0]
              }],
            chart: {
              height: 350,
              type: "area",
              zoom: {
                enabled: true
              }
            },
             theme: {
                 mode: 'dark', 
                 palette: 'palette1', 
                 monochrome: {
                     enabled: false,
                     color: '#255aee',
                     shadeTo: 'dark',
                     shadeIntensity: 0.65
                 },
             },
            dataLabels: {
              enabled: false
            },
            stroke: {
              curve: "straight"
            },
            title: {
              text: "Cihaz Sıcaklık Durumu",
              align: "left"
            },
            xaxis: {
            type: 'category',
              categories: label
            },
            yaxis: {
                labels: {
                  offsetX: 10
                }
              },
              grid: {
                show:true,
                padding: {
                  left: 40,
                  right: 40,
                }
              }
          };
    }

    BatData() {
        var Label = []
        var datasolar = []
        var databat = []
        this._requestStatsList.forEach(element => {
            datasolar.push(parseInt(element.solarEnerjiVoltaj) / 100)
            databat.push(parseInt(element.batarya) / 100)
            Label.push(this.datePipe.transform(element.sonBaglantiTarih,'dd.MM.yyyy HH:mm'));
        });
        this.batChartOptions = {
            series: [{
                name: 'Batarya Durumu',
                data: databat.length>0?databat:[0]
              }, {
                name: 'Solar Batarya Durumu',
                data: datasolar.length>0?datasolar:[0]
            }],
            chart: {
              height: 350,
              type: "area",
              zoom: {
                enabled: true
              }
            },
             theme: {
                 mode: 'dark', 
                 palette: 'palette1', 
                 monochrome: {
                     enabled: false,
                     color: '#255aee',
                     shadeTo: 'dark',
                     shadeIntensity: 0.65
                 },
             },
            dataLabels: {
              enabled: false
            },
            stroke: {
              curve: "straight"
            },
            title: {
              text: "Cihaz Batarya Durumu",
              align: "left"
            },
            xaxis: {
            type: 'category',
              categories: Label
            },
            yaxis: {
                labels: {
                  offsetX: 10
                }
              },
              grid: {
                show:true,
                padding: {
                  left: 40,
                  right: 40,
                }
              }
          };

    }

    MsfData() {
        var label = []
        var datamsf = []
        this._msfList.forEach(element => {
            var date = this.dateConvert.convertToUTC(element.sonBaglantiTarih);
            var calc = ((
                (parseInt(this.container.altitude)-parseInt(this.container.deadZone)) - 
                (parseInt(element.mesafe) - parseInt(this.container.deadZone))
                )*100)/(parseInt(this.container.altitude)-parseInt(this.container.deadZone))
            if(calc<0){
                calc=0;
            }else if(calc>100){
                calc=100;
            }
            datamsf.push(calc.toFixed(2))
            label.push(this.datePipe.transform( date,'dd-MM-yyyy H:mm:ss'));
        });
        
        this.msfChartOptions = {
            series: [
              {
                name: "Doluluk",
                data: datamsf.length>0?datamsf:[0]
              }
            ],
            chart: {
              height: 350,
              type: "line",
              zoom: {
                enabled: true
              }
            },
            yaxis: {
                labels: {
                  offsetX: 10
                },
                max:100,
              },
              grid: {
                show:true,
                padding: {
                  left: 50,
                  right: 50,
                }
              },
             theme: {
                 mode: 'dark', 
                 palette: 'palette1', 
                 monochrome: {
                     enabled: false,
                     color: '#255aee',
                     shadeTo: 'dark',
                     shadeIntensity: 0.65
                 },
             },
            dataLabels: {
              enabled: false
            },
            stroke: {
              curve: "straight"
            },
            title: {
              text: "Cihaz Doluluk Ölçümü",
              align: "left"
            },
            xaxis: {
            type: 'category',
              categories: label
            }
          };
    }

    public async getByDateBetweenRequests() {
        try {
            this._spinner.show('loading')
            this._requestStatsList = await this.deviceRequest.getByDateBetweenRequests(this.deviceId, this.startDate,this.endDate);
            await this.refreshChart()
            this._spinner.hide('loading')
        } catch (error) {
            this._spinner.hide('loading')
            console.warn(error);
        }
    }

    public async refreshChart(){
         this.BatData();
         this.HeatData();
    }

}
